import Layout from '@/layout/index.vue'

const projRoutes = [
    {
        path: '/info',
        name: 'Info',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '简介',
            icon: 'OfficeBuilding'
        },
        children: [
            {
                path: '',
                name: 'Info',
                component: () => import('@/modules/info/proj.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '总览',
                    icon: 'OfficeBuilding'
                }
            },
        ]
    },
    {
        path: '/',
        name: 'Dashboard',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '项目监控',
            icon: 'Monitor'
        },
        redirect: '/dashboard',
        children: [
            {
                path: 'dashboard',
                name: 'ProjectMonitor',
                component: () => import('@/modules/dashboard/project.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '项目监控',
                    icon: 'Monitor'
                }
            }
        ]
    },
    {
        path: '/point',
        name: 'Point',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '监测列表',
            icon: 'Place'
        },
        children: [
            {
                path: '',
                name: 'PointList',
                component: () => import('@/modules/point/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: 'File列表',
                    icon: 'FolderOpened'
                },
            }]
    },
    {
        path: '/device',
        name: 'Device',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '设备管理',
            icon: 'Cpu'
        },
        children: [
            // {
            //     path: 'config',
            //     name: 'Config',
            //     component: () => import('@/modules/point/index.vue'),
            //     meta: {
            //         requiresAuth: true, // 访问该路由需要身份验证
            //         title: '设备配置',
            //         icon: 'Place'
            //     },
            // },
            {
                path: 'terminal',
                name: 'TerminalList',
                component: () => import('@/modules/device/terminal.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '采集设备',
                    icon: 'Cellphone'
                },
            },
            {
                path: 'sensor',
                name: 'SensorList',
                component: () => import('@/modules/device/sensor.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '传感器',
                    icon: 'Odometer'
                },
            },
            // {
            //     path: 'data',
            //     name: 'DataList',
            //     component: () => import('@/modules/data/index.vue'),
            //     meta: {
            //         requiresAuth: true, // 访问该路由需要身份验证
            //         title: '硬件数据',
            //         icon: 'DataAnalysis',
            //     },
            // },
            // {
            //     path: 'other',
            //     name: 'Other',
            //     component: () => import('@/modules/device/other.vue'),
            //     meta: {
            //         requiresAuth: true, // 访问该路由需要身份验证
            //         title: '内部设备',
            //         icon: 'IceCreamSquare',
            //     },
            // }
        ]
    },
    {
        path: '/project',
        name: 'Project',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '平台管理',
            icon: 'OfficeBuilding'
        },
        children: [
            {
                path: 'user',
                name: 'UserList',
                component: () => import('@/modules/user/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '用户管理',
                    icon: 'User'
                },
            },
            {
                path: '',
                name: 'ProejctDetail',
                component: () => import('@/modules/project/edit.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '资源管理',
                    icon: 'SetUp'
                },
            },
            {
                path: 'asset',
                name: 'Assets',
                component: () => import('@/modules/asset/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '资源列表',
                    icon: 'Picture'
                },
            }
        ]
    },
    // {
    //     path: '/data',
    //     name: 'Data',
    //     component: Layout,
    //     meta: {
    //         requiresAuth: true, // 访问该路由需要身份验证
    //         title: '硬件数据',
    //         icon: 'DataAnalysis',
    //     },
    //     children: [
    //         {
    //             path: '',
    //             name: 'DataList',
    //             component: () => import('@/modules/data/index.vue'),
    //             meta: {
    //                 requiresAuth: true, // 访问该路由需要身份验证
    //                 title: '列表'
    //             },
    //         }]
    // },
    // {
    //     path: '/device',
    //     name: 'Device',
    //     component: Layout,
    //     meta: {
    //         requiresAuth: true, // 访问该路由需要身份验证
    //         title: '硬件设备',
    //         icon: 'Cpu'
    //     },
    //     children: [
    //         {
    //             path: 'terminal',
    //             name: 'TerminalList',
    //             component: () => import('@/modules/device/terminal.vue'),
    //             meta: {
    //                 requiresAuth: true, // 访问该路由需要身份验证
    //                 title: '采集终端',
    //                 icon: 'Cellphone'
    //             },
    //         },
    //         {
    //             path: 'sensor',
    //             name: 'SensorList',
    //             component: () => import('@/modules/device/sensor.vue'),
    //             meta: {
    //                 requiresAuth: true, // 访问该路由需要身份验证
    //                 title: '传感器',
    //                 icon: 'Odometer'
    //             },
    //         },
    //     ]
    // },
    // {
    //     path: '/resource',
    //     name: 'Resource',
    //     component: Layout,
    //     meta: {
    //         requiresAuth: true, // 访问该路由需要身份验证
    //         title: '文件资源',
    //         icon: 'Files'
    //     },
    //     children: [
    //         {
    //             path: '',
    //             name: 'Assets',
    //             component: () => import('@/modules/asset/index.vue'),
    //             meta: {
    //                 requiresAuth: true, // 访问该路由需要身份验证
    //                 title: '资源列表',
    //                 icon: 'Picture'
    //             },
    //         }
    //     ]
    // },
    {
        path: '/partner',
        name: 'Partner',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '技术支持',
            icon: 'Connection'
        },
        children: [
            {
                path: '',
                name: 'Honor',
                component: () => import('@/modules/partner/proj.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '资源列表',
                    icon: 'Picture'
                },
            }
        ]
    },
]

export default projRoutes;